import { Form } from 'factorial-form'

import type { IExportShiftsSchedule } from 'modules/shift_management/lib/types'

export interface IExportScheduleFormValues extends Omit<
  IExportShiftsSchedule,
  'start_at' | 'end_at'
> {}

class ExportScheduleForm extends Form {
  constructor(values: Partial<IExportScheduleFormValues> = {}) {
    super(values, {
      exclude_drafts: 'boolean',
      export_by: 'string',
    })
  }
}

export default ExportScheduleForm
